import { HealthcareProviderAppointmentCancellationTokenInConfirmationEnabledQuery } from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationAppointmentCancellationTokenInConfirmationLoaderChildrenRenderProps = {
   notificationEnabled: boolean;
};

type PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggleLoaderProps = {
   readonly children: (
      result: PatientPhoneNotificationAppointmentCancellationTokenInConfirmationLoaderChildrenRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggleLoader = (
   props: PatientPhoneNotificationAppointmentCancellationTokenInConfirmationToggleLoaderProps
): JSX.Element | null => {
   const {
      data: cancellationByResponseMessageEnabled,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
   } = useCqrsGet<boolean>(() => {
      return new HealthcareProviderAppointmentCancellationTokenInConfirmationEnabledQuery();
   });

   if (healthcareProviderNotificationConfigurationLoading || healthcareProviderNotificationConfigurationError) {
      return null;
   }

   return props.children({
      notificationEnabled: cancellationByResponseMessageEnabled,
   });
};
